import { Link } from 'react-router-dom';
import {ArrowRight, ShieldCheck, Clock, Award, Users, Star} from 'lucide-react';
import Layout from '@/components/Layout';
import Container from '@/components/ui/Container';
import SectionHeading from '@/components/ui/SectionHeading';
import TrustBar from '@/components/TrustBar';
import TestimonialsCarousel from '@/components/TestimonialsCarousel';
import ConsultationForm from '@/components/ConsultationForm';
import { services } from '@/data/services';

const stats = [
{ label: 'Projetos entregues', value: '500+', icon: Award },
{ label: 'Anos de experiência', value: '15+', icon: Clock },
{ label: 'Clientes ativos', value: '320+', icon: Users },
{ label: 'Satisfação dos clientes', value: '98%', icon: Star }];


function Home() {
  return (
    <Layout>
      <section className="relative overflow-hidden bg-slate-950">
        <div className="absolute inset-0">
          <img
            src="https://static.lumi.new/29/29efe632b45dee52e260de6f6c553441.png"
            alt="Central de monitoramento de segurança com múltiplas telas de videovigilância"
            className="h-full w-full object-cover opacity-40" />

          <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-slate-950/50" />
        </div>
        <Container className="relative py-24 sm:py-32">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-3 py-1 text-xs font-semibold text-cyan-300">
              <ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" />
              Consultoria em Segurança Tecnológica
            </span>
            <h1 className="mt-6 text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">Protegendo  com tecnologia de ponta 

            </h1>
            <p className="mt-6 text-lg leading-relaxed text-slate-300">
              Somos referência em videovigilância, alarmes, controle de acesso, redes e telecom. As melhores soluções sob medida para empresas e residências.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-cyan-600/20 transition-colors hover:bg-cyan-500">

                Solicitar Consultoria 
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
              <Link
                to="/servicos"
                className="inline-flex items-center justify-center gap-2 rounded-lg border border-white/20 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10">

                Conhecer Soluções
              </Link>
            </div>
          </div>

          <div className="mt-16 grid grid-cols-2 gap-6 border-t border-white/10 pt-10 sm:grid-cols-4">
            {stats.map((stat) =>
            <div key={stat.label}>
                <div className="flex items-center gap-2">
                  <stat.icon className="h-5 w-5 text-cyan-400" aria-hidden="true" />
                  <span className="text-2xl font-bold text-white sm:text-3xl">{stat.value}</span>
                </div>
                <p className="mt-1 text-xs text-slate-400">{stat.label}</p>
              </div>
            )}
          </div>
        </Container>
      </section>

      <TrustBar />

      <section className="py-20 sm:py-24">
        <Container>
          <SectionHeading
            eyebrow="Nossas Soluções"
            title="Leque de soluções completo para o seu negócio"
            description="Oferecemos soluções integradas de segurança eletrônica e infraestrutura de rede." />


          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <Link
                  key={service.id}
                  to={`/servicos/${service.slug}`}
                  className="group flex flex-col rounded-2xl border border-slate-100 p-6 transition-all hover:border-cyan-200 hover:shadow-lg hover:shadow-cyan-50">

                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-cyan-50 text-cyan-600 transition-colors group-hover:bg-cyan-600 group-hover:text-white">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                  </span>
                  <h3 className="mt-5 text-lg font-semibold text-slate-900">{service.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.shortDescription}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-600">
                    Saiba mais
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                </Link>);

            })}
          </div>
        </Container>
      </section>

      <section className="py-20 sm:py-24">
        <Container>
          <SectionHeading
            eyebrow="Depoimentos"
            title="O que nossos clientes dizem"
            align="center" />

          <div className="mt-12">
            <TestimonialsCarousel />
          </div>
        </Container>
      </section>

      <section className="bg-slate-900 py-20 sm:py-24">
        <Container className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <SectionHeading
              eyebrow="Fale com um especialista"
              title="Pronto para elevar a segurança e tecnologia da sua empresa ou residência?"
              description="Preencha o formulário e receba uma proposta personalizada de nossos consultores."
              light />

            <ul className="mt-8 space-y-3 text-sm text-slate-300">
              <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> Diagnóstico gratuito e sem compromisso</li>
              <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> Equipe técnica certificada</li>
              <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 shrink-0 text-cyan-400" aria-hidden="true" /> Suporte contínuo pós-implantação</li>
            </ul>
          </div>
          <div className="rounded-2xl bg-white p-6 shadow-xl sm:p-8">
            <ConsultationForm variant="compact" />
          </div>
        </Container>
      </section>
    </Layout>);

}

export default Home;